import React from 'react'
import { MarginBox, colors, LayoutBand, useTheme, useContainerWidth } from '@fs/zion-ui'
import { flavors } from '../config'

export default function FormContainer({ children, flavor }) {
  const atWidth = useContainerWidth()
  const theme = useTheme()
  const backgroundColor = theme === 'day' && flavor === 'charcoal' ? colors.gray02 : flavors[flavor].solid

  return (
    <LayoutBand
      style={{
        backgroundColor,
        borderRadius: atWidth({ default: 16, lg: 32 }),
        // FIXME: this seems like a hack, but I am not sure a better way to do it
        // this removes the x bleedable sides for the parent layoutband. It also allows some margin on both sides when in mobile; aligns the back button with the edge of this layoutband
        marginInline: 0,
      }}
      marginY="xl"
    >
      {/* Because this is a nested layoutband, we need to force margin on the x instead of letting the layoutband do it */}
      <MarginBox marginX="sm">{children}</MarginBox>
    </LayoutBand>
  )
}
